"use strict";
var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b ||= {})
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
import React from "react";
import { observer } from "mobx-react";
import classNames from "classnames";
import * as styles from "./Panel-css";
import { darkTheme, lightTheme } from "../../../tokens/tokens-css";
let Panel = class extends React.Component {
  render() {
    const { theme, className, style, innerRef, id, role, elevation } = this.props;
    return /* @__PURE__ */ React.createElement(
      "div",
      {
        className: classNames(styles.panel({ elevation }), className, {
          [lightTheme]: theme === "light",
          [darkTheme]: theme === "dark"
        }),
        style,
        ref: innerRef,
        id,
        role
      },
      this.props.children
    );
  }
};
Panel.defaultProps = {
  elevation: 2,
  className: ""
};
Panel = __decorateClass([
  observer
], Panel);
export default React.forwardRef((props, ref) => /* @__PURE__ */ React.createElement(Panel, __spreadProps(__spreadValues({}, props), { innerRef: ref })));
